<template>
  <v-dialog v-model="isprofileUpdated" width="500" persistent>
    <v-card :loading="loading">
      <v-card-title class="db white--text" primary-title>
        <h5 class="font-weight-regular">Complete Profile</h5>
      </v-card-title>
      <v-container>
        <v-form ref="profileForm">
          <v-layout>
            <v-flex md6 class="ma-2">
              <v-text-field
                v-model.trim="fullName"
                :rules="rules.fullName"
                outline
                placeholder="Full name"
              ></v-text-field>
            </v-flex>
            <v-flex md6 class="ma-2">
              <v-text-field
                v-model.trim="schoolName"
                :rules="rules.required"
                outline
                placeholder="School Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6 class="ma-2">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dob"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dob"
                    :rules="rules.required"
                    readonly
                    v-on="on"
                    label="Date of Birth"
                  ></v-text-field>
                </template>
                <v-date-picker ref="datePicker" :max="maxDate" v-model="dob" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(dob)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md6 class="ma-2">
              <v-select v-model="grade" :items="grades" :rules="rules.required" label="Grade"></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6 class="ma-2">
              <v-text-field
                v-model.trim="city"
                :rules="rules.required"
                maxlength="15"
                outline
                placeholder="City"
              ></v-text-field>
            </v-flex>
            <v-flex md6 class="ma-2">
              <v-text-field
                :rules="rules.validNumber"
                v-model.trim.number="mobileNumber"
                outline
                type="number"
                placeholder="Mobile Number"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <PrivacyPolicy :pp="pp" @close="pp = false" />
        </v-form>

        <v-layout class="caption font-italic ma-1" column>
          You will only see the exercises and olympiads that are available for your particular grade, so make sure to select the correct one.
          <br />
          <p class="mt-2">
            By submitting the above details, you agree to our
            <b
              class="cursor"
              @click="pp =true"
            >privacy policy.</b>
          </p>
        </v-layout>
      </v-container>

      <v-divider></v-divider>
      <p v-if="error" class="caption red--text my-2 mx-5">{{error}}</p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" @click="submit" color="primary" text>Save Profile</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PrivacyPolicy from "./PrivacyPolicy";
import { mapActions, mapMutations } from "vuex";
export default {
  props: ["isprofileUpdated"],
  components: {
    PrivacyPolicy
  },
  data() {
    return {
      pp: false,
      maxDate: new Date(`${new Date().getFullYear() - 13}`).toISOString(),
      error: "",
      dob: "",
      city: "",
      fullName: "",
      schoolName: "",
      grade: "",
      mobileNumber: "",
      loading: false,
      menu: false,
      grades: [
        { text: "6th", value: 6 },
        { text: "7th", value: 7 },
        { text: "8th", value: 8 },
        { text: "9th", value: 9 },
        { text: "10th", value: 10 },
        { text: "11th", value: 11 },
        { text: "12th", value: 12 },
        { text: "Above", value: 13 }
      ],
      rules: {
        required: [v => !!v || "This field is required"],
        fullName: [
          v => (!!v && v.split(" ").length === 2) || "Enter your full name"
        ],
        validNumber: [
          v =>
            (v && v.toString().length > 9 && v.toString().length < 13) ||
            "Enter a valid phone number"
        ]
      }
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.datePicker.activePicker = "YEAR"));
    }
  },
  methods: {
    ...mapActions(["saveProfileInformation"]),
    ...mapMutations(["sanitizeUpdateProfile"]),
    async submit() {
      if (!this.$refs.profileForm.validate()) return;
      this.loading = true;
      try {
        const saveProfile = await this.saveProfileInformation({
          fullName: this.fullName,
          city: this.city,
          dob: this.dob,
          schoolName: this.schoolName,
          grade: this.grade,
          mobileNumber: this.mobileNumber
        });
        this.sanitizeUpdateProfile();
      } catch (err) {
        this.error = err || "Something went wrong";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style >
.cursor {
  cursor: pointer;
}
</style>